import {lazy, Suspense} from 'react';

import useCurrentUserQuery from '@/shared/queries/useCurrentUserQuery';
import {ApiErrorBoundary} from '@/shared/ui/api-error-boundary';
import {Card} from '@/shared/ui/card';
import {ErrorMessage} from '@/shared/ui/error-message';
import {Loading} from '@/shared/ui/loading';
import {useQueryClient} from '@tanstack/react-query';

import {getComparisonByCourseQueryKeys} from '../../queries/useGetComparisonByCourseQuery';

import styles from './ComparisonByCourse.module.scss';

const LazyComparisonByCourse = lazy(() => import('./ComparisonByCourse'));

const ComparisonByCourseContainer = () => {
  const {user} = useCurrentUserQuery();
  const queryClient = useQueryClient();

  const onReset = () => {
    queryClient.resetQueries({
      queryKey: getComparisonByCourseQueryKeys(user.institutionId),
    });
  };

  return (
    <Card className={styles.ComparisonByCourse}>
      <ApiErrorBoundary fallback={ErrorMessage} onReset={onReset}>
        <Suspense fallback={<Loading />}>
          <LazyComparisonByCourse key={user.institutionId} />
        </Suspense>
      </ApiErrorBoundary>
    </Card>
  );
};

export default ComparisonByCourseContainer;
